import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { MdDownload, MdRefresh } from 'react-icons/md';
import { useLocation, useHistory } from 'react-router-dom';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import PortalButton from './PortalButton';
import PortalModal from './PortalModal';
import { usePortalMutation, useExportStatus, useExportDownload } from '../hooks';
import { ErrorNotice, Status, Loading } from './Feedback';

export default function ExportStatus({ filters }) {
  const [open, setOpen] = useState(false);
  const location = useLocation(),
    history = useHistory(),
    params = new URLSearchParams(location.search),
    id = params.get('exportId');
  const create = usePortalMutation('exportacoes'),
    query = useExportStatus(id),
    download = useExportDownload();
  const generate = () =>
    create.mutate(
      { ...filters },
      {
        onSuccess: (response) => {
          params.set('exportId', response.data.id);
          history.replace({ pathname: location.pathname, search: params.toString() });
        },
      }
    );
  return (
    <>
      <PortalButton
        className="btn btn-warning hidethis"
        disabled={!create.allowed && !id}
        onClick={() => setOpen(true)}
      >
        <MdDownload /> Planilha de inscrições
      </PortalButton>
      {open && (
        <PortalModal
          title="Planilha de inscrições"
          description="A exportação considera os filtros aplicados na listagem."
          icon={<MdDownload />}
          busy={create.isLoading || download.isLoading}
          onClose={() => setOpen(false)}
        >
          <Modal.Body>
            <ErrorNotice error={create.error || query.error || download.error} />
            {id && query.isLoading ? (
              <Loading />
            ) : query.data ? (
              <div className="portal-admin-progress">
                <Status value={query.data.status} />
                <p>
                  {query.data.progress} de {query.data.total} registros
                </p>
                <progress max={query.data.total || 1} value={query.data.progress} />
                {query.data.error && <div className="alert alert-danger">{query.data.error}</div>}
              </div>
            ) : (
              <p>Gere a planilha para consultar as inscrições correspondentes à pesquisa atual.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <DefaultButton
              text="Fechar"
              bg="secondary"
              disabled={create.isLoading || download.isLoading}
              onClick={() => setOpen(false)}
            />
            {query.data?.status === 'complete' ? (
              <>
                <PortalButton
                  className="btn btn-success"
                  disabled={create.isLoading || !create.allowed}
                  onClick={generate}
                >
                  <MdRefresh /> Gerar novamente
                </PortalButton>
                <PortalButton
                  className="btn btn-secondary"
                  disabled={download.isLoading}
                  onClick={() =>
                    download.mutate(id, { onSuccess: (url) => window.location.assign(url) })
                  }
                >
                  <MdDownload /> Baixar planilha
                </PortalButton>
              </>
            ) : (
              <PortalButton
                className="btn btn-success"
                disabled={
                  create.isLoading ||
                  !create.allowed ||
                  (!!id && query.isLoading) ||
                  ['queued', 'pending', 'processing'].includes(query.data?.status)
                }
                onClick={generate}
              >
                <MdDownload /> Gerar planilha
              </PortalButton>
            )}
          </Modal.Footer>
        </PortalModal>
      )}
    </>
  );
}
